import { FormInstance } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId, UserType } from 'api/models';
import { Project } from 'api/project';
import { Form } from 'components/atoms/form';
import { AllUserInvitation } from 'components/organisms/project-invitations';
import { useInAndNotInProjectUsers } from 'hooks/use-assignee-options';
import { useUser } from 'hooks/use-user';
import { useAccountSettingsMembersWsUpdates } from 'hooks/websockets';
import { useAccountUserWsUpdates } from 'hooks/websockets/use-account-user-websocket';

const FormItem = styled(Form.Item)`
  display: flex;
  flex-direction: column;
`;

export const InviteUserInputV2: FC<{
  project: Project;
  form: FormInstance;
}> = ({ project, form }) => {
  useAccountSettingsMembersWsUpdates();
  useAccountUserWsUpdates();
  const loggedInUser = useUser();
  const { inProjectUsers, notInProjectUsers } = useInAndNotInProjectUsers({
    projectId: ProjectId(project.projectId),
  });
  const currentUserType = loggedInUser.user.userType;

  return (
    <FormItem
      data-cy="projectMembers"
      name="projectMembers"
      label={
        currentUserType === UserType.Native ||
        currentUserType === UserType.External ? (
          <FormattedMessage id="project.invitation.label.native" />
        ) : currentUserType === UserType.Partner ? (
          <FormattedMessage id="project.invitation.label.partner" />
        ) : null
      }
      colon={false}
      labelAlign="left"
    >
      <AllUserInvitation
        allInProjectUsers={inProjectUsers}
        allNotInProjectUsers={notInProjectUsers}
        project={project}
        currentUserType={currentUserType}
        currentUserCompany={loggedInUser.company}
        buttonText={<FormattedMessage id="invite" />}
        form={form}
      />
    </FormItem>
  );
};
